import React, {ComponentProps} from 'react';

import Col from '../../common/Col';
import Row from '../../common/Row';
import {isNullish} from '../../common/util';
import {Review} from '../marketplace/types';
import StarRatings from './StarRatings';

type ReviewListProps = ComponentProps<'div'> & {
  title: string;
  count: number;
  average: number;
  list: Review[];
};

const ReviewList = ({className, title, count, average, list = []}: ReviewListProps) => {
  return (
    <div className={className}>
      <Row className={'justify-between'}>
        <h2 className="font-semibold text-2xl">
          {title} ({count})
        </h2>
        {/* TODO - disable while we don't have the review functionality ready. */}
        {/*<Button variant="secondary">Write a review</Button>*/}
      </Row>
      <div className="mt-xs text-primary-800 font-semibold">{average.toFixed(1)}/5</div>
      <StarRatings className="my-2" rating={average} />
      <div className="text-primary-800 text-sm">{count} customer reviews</div>
      <Col>
        {list.map((r, i) => (
          <Col className="mt-md pt-sm border-t border-gray-100 space-y-2" key={`review_${i}`}>
            <Row className={'justify-between items-center'}>
              <div>{r.name}</div>
              <div className={'text-xs text-gray-200'}>{r.date}</div>
            </Row>
            {!isNullish(r.rating) && <StarRatings rating={r.rating} />}
            <p className="text-primary-800 text-sm">{r.text}</p>
          </Col>
        ))}
      </Col>
    </div>
  );
};

export default ReviewList;
